import { render, staticRenderFns } from "./MayorBook.vue?vue&type=template&id=6f2e5dfe&scoped=true"
import script from "./MayorBook.vue?vue&type=script&lang=js"
export * from "./MayorBook.vue?vue&type=script&lang=js"
import style0 from "./MayorBook.vue?vue&type=style&index=0&id=6f2e5dfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2e5dfe",
  null
  
)

export default component.exports